/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';
import { DocumentsAPI } from '../common/documents';

const baseUrl = `/api/internal`;

export const documentsClient = (request: AxiosInstance) => ({
  async fetchCallDocuments(callId: string): Promise<DocumentsAPI.DocumentsResponse> {
    return (await request.get(`${baseUrl}/calls/${callId}/documents`)).data;
  },

  async fetchCallDocumentPdf(callId: string, documentId: string): Promise<string> {
    const res = await request.get(`${baseUrl}/calls/${callId}/documents/${documentId}/download`, {
      responseType: 'blob',
    });
    const file = new Blob([res.data], {
      type: 'application/pdf',
    });
    return URL.createObjectURL(file);
  },

  async fetchDocumentSigningUrl(
    callId: string,
    documentId: string,
    participantSessionId: string,
  ): Promise<DocumentsAPI.UrlResponse> {
    return (
      await request.get(
        `${baseUrl}/calls/${callId}/documents/${documentId}/participant-sessions/${participantSessionId}/sign`,
      )
    ).data;
  },

  async fetchActionForSession(callId: string): Promise<DocumentsAPI.ActionResponse> {
    return (await request.get(`${baseUrl}/calls/${callId}/action`)).data;
  },

  async handleSigning(callId: string, documentId: string, participantSessionId: string): Promise<void> {
    await request.get(
      `${baseUrl}/calls/${callId}/documents/${documentId}/participant-sessions/${participantSessionId}/handle-signing`,
    );
  },
});
